import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { Translate, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { ILanguage } from 'app/shared/model/language.model';
import { getEntities as getLanguages } from 'app/entities/language/language.reducer';
import { IUser } from 'app/shared/model/user.model';
import { getUsers } from 'app/modules/administration/user-management/user-management.reducer';
import { IDestination } from 'app/shared/model/destination.model';
import { getEntities as getDestinations } from 'app/entities/destination/destination.reducer';
import { ITourCategory } from 'app/shared/model/tour-category.model';
import { getEntities as getTourCategories } from 'app/entities/tour-category/tour-category.reducer';
import { IPlace } from 'app/shared/model/place.model';
import { getEntities as getPlaces } from 'app/entities/place/place.reducer';
import { IPlaceCategory } from 'app/shared/model/place-category.model';
import { getEntities as getPlaceCategories } from 'app/entities/place-category/place-category.reducer';
import { ITourExtraCategory } from 'app/shared/model/tour-extra-category.model';
import { getEntities as getTourExtraCategories } from 'app/entities/tour-extra-category/tour-extra-category.reducer';
import { ITourExtra } from 'app/shared/model/tour-extra.model';
import { getEntities as getTourExtras } from 'app/entities/tour-extra/tour-extra.reducer';
import { IMenu } from 'app/shared/model/menu.model';
import { getEntities as getMenus } from 'app/entities/menu/menu.reducer';
import { IWebPage } from 'app/shared/model/web-page.model';
import { getEntities as getWebPages } from 'app/entities/web-page/web-page.reducer';
import { ITag } from 'app/shared/model/tag.model';
import { getEntities as getTags } from 'app/entities/tag/tag.reducer';
import { ITourStep } from 'app/shared/model/tour-step.model';
import { getEntities as getTourSteps } from 'app/entities/tour-step/tour-step.reducer';
import { IPromotion } from 'app/shared/model/promotion.model';
import { getEntities as getPromotions } from 'app/entities/promotion/promotion.reducer';
import { IImageFile } from 'app/shared/model/image-file.model';
import { getEntities as getImageFiles } from 'app/entities/image-file/image-file.reducer';
import { IContent } from 'app/shared/model/content.model';
import { getEntity, updateEntity, createEntity, reset } from './content.reducer';

export const ContentUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const languages = useAppSelector(state => state.language.entities);
  const users = useAppSelector(state => state.userManagement.users);
  const account = useAppSelector(state => state.authentication.account);
  const destinations = useAppSelector(state => state.destination.entities);
  const tourCategories = useAppSelector(state => state.tourCategory.entities);
  const places = useAppSelector(state => state.place.entities);
  const placeCategories = useAppSelector(state => state.placeCategory.entities);
  const tourExtraCategories = useAppSelector(state => state.tourExtraCategory.entities);
  const tourExtras = useAppSelector(state => state.tourExtra.entities);
  const menus = useAppSelector(state => state.menu.entities);
  const webPages = useAppSelector(state => state.webPage.entities);
  const tags = useAppSelector(state => state.tag.entities);
  const tourSteps = useAppSelector(state => state.tourStep.entities);
  const promotions = useAppSelector(state => state.promotion.entities);
  const imageFiles = useAppSelector(state => state.imageFile.entities);
  const contentEntity = useAppSelector(state => state.content.entity);
  const loading = useAppSelector(state => state.content.loading);
  const updating = useAppSelector(state => state.content.updating);
  const updateSuccess = useAppSelector(state => state.content.updateSuccess);

  const [formData, setFormData] = useState<any>({
    createdBy: account?.id,
  });
  const [errors, setErrors] = useState<Record<string, string>>({});

  const handleClose = () => {
    navigate('/content' + location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
      setFormData({
        createdBy: account?.id,
      });
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getLanguages({}));
    dispatch(getUsers({}));
    dispatch(getDestinations({}));
    dispatch(getTourCategories({ size: 1000 }));
    dispatch(getPlaces({ size: 1000 }));
    dispatch(getPlaceCategories({ size: 1000 }));
    dispatch(getTourExtraCategories({ size: 1000 }));
    dispatch(getTourExtras({ size: 1000 }));
    dispatch(getMenus({ size: 1000 }));
    dispatch(getWebPages({ size: 1000 }));
    dispatch(getTags({ size: 1000 }));
    dispatch(getTourSteps({ size: 1000 }));
    dispatch(getPromotions({ size: 1000 }));
    dispatch(getImageFiles({ size: 1000 }));
  }, []);

  useEffect(() => {
    if (contentEntity) {
      setFormData({
        ...contentEntity,
        language: contentEntity?.language?.id,
        createdBy: contentEntity?.createdBy?.id,
        destination: contentEntity?.destination?.id,
        tourCategory: contentEntity?.tourCategory?.id,
        place: contentEntity?.place?.id,
        placeCategory: contentEntity?.placeCategory?.id,
        tourExtraCategory: contentEntity?.tourExtraCategory?.id,
        tourExtra: contentEntity?.tourExtra?.id,
        menu: contentEntity?.menu?.id,
        webPage: contentEntity?.webPage?.id,
        tag: contentEntity?.tag?.id,
        tourStep: contentEntity?.tourStep?.id,
        promotion: contentEntity?.promotion?.id,
        imageFile: contentEntity?.imageFile?.id,
      });
    }
  }, [contentEntity]);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const validate = (): boolean => {
    const newErrors: Record<string, string> = {};
    if (!formData.code || formData.code.trim() === '') {
      newErrors.code = 'Code is required';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (field: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [field]: event.target.value });
    if (errors[field]) {
      setErrors({ ...errors, [field]: '' });
    }
  };

  const handleSelectChange = (field: string) => (event: any) => {
    setFormData({ ...formData, [field]: event.target.value });
    if (errors[field]) {
      setErrors({ ...errors, [field]: '' });
    }
  };

  // eslint-disable-next-line complexity
  const saveEntity = () => {
    if (!validate()) {
      return;
    }

    const values = { ...formData };

    if (values.id !== undefined && typeof values.id !== 'number') {
      values.id = Number(values.id);
    }

    values.language = values.language || null;
    values.destination = values.destination || null;
    values.tourCategory = values.tourCategory || null;
    values.place = values.place || null;
    values.placeCategory = values.placeCategory || null;
    values.tourExtraCategory = values.tourExtraCategory || null;
    values.tourExtra = values.tourExtra || null;
    values.menu = values.menu || null;
    values.webPage = values.webPage || null;
    values.tag = values.tag || null;
    values.tourStep = values.tourStep || null;
    values.promotion = values.promotion || null;
    values.imageFile = values.imageFile || null;

    const entity = {
      ...contentEntity,
      ...values,
      language: languages.find(it => it.id.toString() === values.language?.toString()),
      createdBy: users.find(it => it.id.toString() === values.createdBy?.toString()),
      destination: destinations.find(it => it.id.toString() === values.destination?.toString()),
      tourCategory: tourCategories.find(it => it.id.toString() === values.tourCategory?.toString()),
      place: places.find(it => it.id.toString() === values.place?.toString()),
      placeCategory: placeCategories.find(it => it.id.toString() === values.placeCategory?.toString()),
      tourExtraCategory: tourExtraCategories.find(it => it.id.toString() === values.tourExtraCategory?.toString()),
      tourExtra: tourExtras.find(it => it.id.toString() === values.tourExtra?.toString()),
      menu: menus.find(it => it.id.toString() === values.menu?.toString()),
      webPage: webPages.find(it => it.id.toString() === values.webPage?.toString()),
      tag: tags.find(it => it.id.toString() === values.tag?.toString()),
      tourStep: tourSteps.find(it => it.id.toString() === values.tourStep?.toString()),
      promotion: promotions.find(it => it.id.toString() === values.promotion?.toString()),
      imageFile: imageFiles.find(it => it.id.toString() === values.imageFile?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  return (
    <Box sx={{ maxWidth: 1200, mx: 'auto', mt: 4, p: 2 }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" component="h2">
          <Translate contentKey="jhipsterSampleApplicationApp.content.home.createOrEditLabel">Create or edit a Content</Translate>
        </Typography>
      </Box>
      <Box component="form" sx={{ '& .MuiTextField-root': { mb: 2 } }} noValidate autoComplete="off">
        {loading ? (
          <Typography>Loading...</Typography>
        ) : (
          <Box sx={{ '& .MuiTextField-root': { mb: 2 } }}>
            {!isNew ? (
              <TextField id="content-id" name="id" label={translate('global.field.id')} value={formData.id || ''} fullWidth InputProps={{ readOnly: true }} />
            ) : null}
            <TextField
              label={translate('jhipsterSampleApplicationApp.content.code')}
              id="content-code"
              name="code"
              data-cy="code"
              value={formData.code || ''}
              onChange={handleChange('code')}
              fullWidth
              required
              error={!!errors.code}
              helperText={errors.code || ''}
            />
            <TextField
              label={translate('jhipsterSampleApplicationApp.content.title')}
              id="content-title"
              name="title"
              data-cy="title"
              value={formData.title || ''}
              onChange={handleChange('title')}
              fullWidth
            />
            <TextField
              label={translate('jhipsterSampleApplicationApp.content.shortDescription')}
              id="content-shortDescription"
              name="shortDescription"
              data-cy="shortDescription"
              value={formData.shortDescription || ''}
              onChange={handleChange('shortDescription')}
              fullWidth
            />
            <TextField
              label={translate('jhipsterSampleApplicationApp.content.data')}
              id="content-data"
              name="data"
              data-cy="data"
              value={formData.data || ''}
              onChange={handleChange('data')}
              fullWidth
              multiline
              minRows={3}
            />
            <TextField
              label={translate('jhipsterSampleApplicationApp.content.meta')}
              id="content-meta"
              name="meta"
              data-cy="meta"
              value={formData.meta || ''}
              onChange={handleChange('meta')}
              fullWidth
              multiline
              minRows={3}
            />
            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel id="content-language-label">{translate('jhipsterSampleApplicationApp.content.language')}</InputLabel>
              <Select
                labelId="content-language-label"
                id="content-language"
                name="language"
                data-cy="language"
                value={formData.language || ''}
                label={translate('jhipsterSampleApplicationApp.content.language')}
                onChange={handleSelectChange('language')}
              >
                <MenuItem value="" key="0">
                  <em>Select...</em>
                </MenuItem>
                {languages
                  ? languages.map(otherEntity => (
                      <MenuItem value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.code}
                      </MenuItem>
                    ))
                  : null}
              </Select>
            </FormControl>
            <FormControl fullWidth>
              <InputLabel id="content-destination-label">{translate('jhipsterSampleApplicationApp.content.destination')}</InputLabel>
              <Select
                labelId="content-destination-label"
                id="content-destination"
                name="destination"
                data-cy="destination"
                value={formData.destination || ''}
                label={translate('jhipsterSampleApplicationApp.content.destination')}
                onChange={handleSelectChange('destination')}
              >
                <MenuItem value="" key="0">
                  <em>Select...</em>
                </MenuItem>
                {destinations
                  ? destinations.map(otherEntity => (
                      <MenuItem value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.code}
                      </MenuItem>
                    ))
                  : null}
              </Select>
            </FormControl>
            <FormControl fullWidth>
              <InputLabel id="content-tourCategory-label">{translate('jhipsterSampleApplicationApp.content.tourCategory')}</InputLabel>
              <Select
                labelId="content-tourCategory-label"
                id="content-tourCategory"
                name="tourCategory"
                data-cy="tourCategory"
                value={formData.tourCategory || ''}
                label={translate('jhipsterSampleApplicationApp.content.tourCategory')}
                onChange={handleSelectChange('tourCategory')}
              >
                <MenuItem value="" key="0">
                  <em>Select...</em>
                </MenuItem>
                {tourCategories
                  ? tourCategories.map(otherEntity => (
                      <MenuItem value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.code}
                      </MenuItem>
                    ))
                  : null}
              </Select>
            </FormControl>
            <FormControl fullWidth>
              <InputLabel id="content-place-label">{translate('jhipsterSampleApplicationApp.content.place')}</InputLabel>
              <Select
                labelId="content-place-label"
                id="content-place"
                name="place"
                data-cy="place"
                value={formData.place || ''}
                label={translate('jhipsterSampleApplicationApp.content.place')}
                onChange={handleSelectChange('place')}
              >
                <MenuItem value="" key="0">
                  <em>Select...</em>
                </MenuItem>
                {places
                  ? places.map(otherEntity => (
                      <MenuItem value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.code}
                      </MenuItem>
                    ))
                  : null}
              </Select>
            </FormControl>
            <FormControl fullWidth>
              <InputLabel id="content-placeCategory-label">{translate('jhipsterSampleApplicationApp.content.placeCategory')}</InputLabel>
              <Select
                labelId="content-placeCategory-label"
                id="content-placeCategory"
                name="placeCategory"
                data-cy="placeCategory"
                value={formData.placeCategory || ''}
                label={translate('jhipsterSampleApplicationApp.content.placeCategory')}
                onChange={handleSelectChange('placeCategory')}
              >
                <MenuItem value="" key="0">
                  <em>Select...</em>
                </MenuItem>
                {placeCategories
                  ? placeCategories.map(otherEntity => (
                      <MenuItem value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.code}
                      </MenuItem>
                    ))
                  : null}
              </Select>
            </FormControl>
            <FormControl fullWidth>
              <InputLabel id="content-tourExtraCategory-label">
                {translate('jhipsterSampleApplicationApp.content.tourExtraCategory')}
              </InputLabel>
              <Select
                labelId="content-tourExtraCategory-label"
                id="content-tourExtraCategory"
                name="tourExtraCategory"
                data-cy="tourExtraCategory"
                value={formData.tourExtraCategory || ''}
                label={translate('jhipsterSampleApplicationApp.content.tourExtraCategory')}
                onChange={handleSelectChange('tourExtraCategory')}
              >
                <MenuItem value="" key="0">
                  <em>Select...</em>
                </MenuItem>
                {tourExtraCategories
                  ? tourExtraCategories.map(otherEntity => (
                      <MenuItem value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.code}
                      </MenuItem>
                    ))
                  : null}
              </Select>
            </FormControl>
            <FormControl fullWidth>
              <InputLabel id="content-tourExtra-label">{translate('jhipsterSampleApplicationApp.content.tourExtra')}</InputLabel>
              <Select
                labelId="content-tourExtra-label"
                id="content-tourExtra"
                name="tourExtra"
                data-cy="tourExtra"
                value={formData.tourExtra || ''}
                label={translate('jhipsterSampleApplicationApp.content.tourExtra')}
                onChange={handleSelectChange('tourExtra')}
              >
                <MenuItem value="" key="0">
                  <em>Select...</em>
                </MenuItem>
                {tourExtras
                  ? tourExtras.map(otherEntity => (
                      <MenuItem value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.code}
                      </MenuItem>
                    ))
                  : null}
              </Select>
            </FormControl>
            <FormControl fullWidth>
              <InputLabel id="content-menu-label">{translate('jhipsterSampleApplicationApp.content.menu')}</InputLabel>
              <Select
                labelId="content-menu-label"
                id="content-menu"
                name="menu"
                data-cy="menu"
                value={formData.menu || ''}
                label={translate('jhipsterSampleApplicationApp.content.menu')}
                onChange={handleSelectChange('menu')}
              >
                <MenuItem value="" key="0">
                  <em>Select...</em>
                </MenuItem>
                {menus
                  ? menus.map(otherEntity => (
                      <MenuItem value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.code}
                      </MenuItem>
                    ))
                  : null}
              </Select>
            </FormControl>
            <FormControl fullWidth>
              <InputLabel id="content-webPage-label">{translate('jhipsterSampleApplicationApp.content.webPage')}</InputLabel>
              <Select
                labelId="content-webPage-label"
                id="content-webPage"
                name="webPage"
                data-cy="webPage"
                value={formData.webPage || ''}
                label={translate('jhipsterSampleApplicationApp.content.webPage')}
                onChange={handleSelectChange('webPage')}
              >
                <MenuItem value="" key="0">
                  <em>Select...</em>
                </MenuItem>
                {webPages
                  ? webPages.map(otherEntity => (
                      <MenuItem value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.code}
                      </MenuItem>
                    ))
                  : null}
              </Select>
            </FormControl>
            <FormControl fullWidth>
              <InputLabel id="content-tag-label">{translate('jhipsterSampleApplicationApp.content.tag')}</InputLabel>
              <Select
                labelId="content-tag-label"
                id="content-tag"
                name="tag"
                data-cy="tag"
                value={formData.tag || ''}
                label={translate('jhipsterSampleApplicationApp.content.tag')}
                onChange={handleSelectChange('tag')}
              >
                <MenuItem value="" key="0">
                  <em>Select...</em>
                </MenuItem>
                {tags
                  ? tags.map(otherEntity => (
                      <MenuItem value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.code}
                      </MenuItem>
                    ))
                  : null}
              </Select>
            </FormControl>
            <FormControl fullWidth>
              <InputLabel id="content-tourStep-label">{translate('jhipsterSampleApplicationApp.content.tourStep')}</InputLabel>
              <Select
                labelId="content-tourStep-label"
                id="content-tourStep"
                name="tourStep"
                data-cy="tourStep"
                value={formData.tourStep || ''}
                label={translate('jhipsterSampleApplicationApp.content.tourStep')}
                onChange={handleSelectChange('tourStep')}
              >
                <MenuItem value="" key="0">
                  <em>Select...</em>
                </MenuItem>
                {tourSteps
                  ? tourSteps.map(otherEntity => (
                      <MenuItem value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.code}
                      </MenuItem>
                    ))
                  : null}
              </Select>
            </FormControl>
            <FormControl fullWidth>
              <InputLabel id="content-promotion-label">{translate('jhipsterSampleApplicationApp.content.promotion')}</InputLabel>
              <Select
                labelId="content-promotion-label"
                id="content-promotion"
                name="promotion"
                data-cy="promotion"
                value={formData.promotion || ''}
                label={translate('jhipsterSampleApplicationApp.content.promotion')}
                onChange={handleSelectChange('promotion')}
              >
                <MenuItem value="" key="0">
                  <em>Select...</em>
                </MenuItem>
                {promotions
                  ? promotions.map(otherEntity => (
                      <MenuItem value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.code}
                      </MenuItem>
                    ))
                  : null}
              </Select>
            </FormControl>
            <FormControl fullWidth>
              <InputLabel id="content-imageFile-label">{translate('jhipsterSampleApplicationApp.content.imageFile')}</InputLabel>
              <Select
                labelId="content-imageFile-label"
                id="content-imageFile"
                name="imageFile"
                data-cy="imageFile"
                value={formData.imageFile || ''}
                label={translate('jhipsterSampleApplicationApp.content.imageFile')}
                onChange={handleSelectChange('imageFile')}
              >
                <MenuItem value="" key="0">
                  <em>Select...</em>
                </MenuItem>
                {imageFiles
                  ? imageFiles.map(otherEntity => (
                      <MenuItem value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.code}
                      </MenuItem>
                    ))
                  : null}
              </Select>
            </FormControl>
            <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
              <Button
                component={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/content"
                replace
                color="info"
                variant="outlined"
                startIcon={<FontAwesomeIcon icon="arrow-left" />}
              >
                <Translate contentKey="entity.action.back">Back</Translate>
              </Button>
              <Button
                color="primary"
                id="save-entity"
                data-cy="entityCreateSaveButton"
                onClick={saveEntity}
                disabled={updating}
                variant="contained"
                startIcon={<FontAwesomeIcon icon="save" />}
              >
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default ContentUpdate;
